import { match } from "ts-pattern";
import { Applications, ProductPermission, StudioPermission, } from "@biggeo/bg-server-lib/studio";
export const BIG_GEO_SUPPORT_EMAIL = "support@biggeo.com";
export const SAVED_AREAS_CREATION_LIMIT = 50;
export const SAVED_VIEWS_CREATION_LIMIT = 50;
export const ORIGINAL_SOURCE_FOLDER_NAME = "original-sources";
export const BG_PARQUET_FOLDER_NAME = "ICBINP";
export const BG_PARQUET_FILE_NAME = "bg-parquet.parquet";
export var BillingEventName;
(function (BillingEventName) {
    BillingEventName["BG_VELOCITY_CHARGE"] = "BG_VELOCITY_CHARGE";
})(BillingEventName || (BillingEventName = {}));
export const productPrice = {
    [BillingEventName.BG_VELOCITY_CHARGE]: 5000,
};
export const BG_GENERATE_ID_NAME = "BG_ID";
var DownloadType;
(function (DownloadType) {
    DownloadType["files"] = "files";
    DownloadType["folders"] = "folders";
})(DownloadType || (DownloadType = {}));
var CloudStorageType;
(function (CloudStorageType) {
    CloudStorageType["Aws"] = "Aws";
    CloudStorageType["Azure"] = "Azure";
    CloudStorageType["Sf"] = "Sf";
    CloudStorageType["Gcp"] = "Gcp";
    CloudStorageType["Upload"] = "Upload";
    CloudStorageType["GoogleDrive"] = "GoogleDrive";
})(CloudStorageType || (CloudStorageType = {}));
var FileType;
(function (FileType) {
    FileType["csv"] = "csv";
    FileType["parquet"] = "parquet";
    FileType["shp"] = "shp";
    FileType["geojson"] = "geojson";
    FileType["geoparquet"] = "geoparquet";
    FileType["gpkg"] = "gpkg";
    FileType["json"] = "json";
    FileType["xls"] = "xls";
    FileType["xlsx"] = "xlsx";
    FileType["xlsm"] = "xlsm";
    FileType["xlsb"] = "xlsb";
    FileType["odf"] = "odf";
    FileType["ods"] = "ods";
    FileType["odt"] = "odt";
    FileType["unsupported"] = "unsupported";
    FileType["zip"] = "zip";
})(FileType || (FileType = {}));
export const CSV_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/csvFileIcon.png";
export const PARQUET_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/ParquetFileIcon.png";
export const SHAPEFILE_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/ShapefileFileIcon.png";
export const JSON_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/json-logo.png";
export const GEOJSON_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/geojson-logo.png";
export const ODF_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/OdfFileIcon.png";
export const ODT_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/OdtFileIcon.png";
export const ODS_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/OdsFileIcon.png";
export const XLS_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/excel-logo.png";
export const XLSM_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/XlsmFileIcon.png";
export const XLSX_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/XlsxFileIcon.png";
export const XLSB_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/XlsbFileIcon.png";
export const GEOPACKAGE_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/GeoPackageFileIcon.png";
export const GEOPARQUET_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/GeoParquetFileIcon.png";
export const UNSUPPORTED_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/Files%20Icons.png";
export const ZIP_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/ZIP%20File.png";
export const AWS_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/AwsAvatar.png";
export const AZURE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/AzureAvatar.png";
export const STRIPE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/StripeLogo.png";
export const SNOWFLAKE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/sf.png";
export const DATALAB_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/Datalab_Icon.png";
export const GCP_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/GCP_LOGO.png";
export const GOOGLE_DRIVE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/Google_Drive_Logo.png";
export const SELLER_PROGRAM_IMAGE = "https://sabiggeomedia01.blob.core.windows.net/media/SellerProgram.png";
export const NO_ACCESS_KEYS_FEATURE_IMAGE = "https://sabiggeomedia01.blob.core.windows.net/media/NoAccessKeysFeature.png";
export const NO_ADD_DATASOURCE_FEATURE_IMAGE = "https://sabiggeomedia01.blob.core.windows.net/media/NoAddDatasourceFeature.png";
export const UPLOAD_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/2025-04-29T22%3A03%3A04-Icon.png";
export const BG_MARKETPLACE_CIRCULAR_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/MarketplaceCircularIcon.png";
export const FILES_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/Files%20Icons.png";
export const FOLDERS_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/folderIcons.png";
export const BG_FACE_ID = "BG_FACE_ID";
export const googleOAuthScope = {
    gcpRead: "https://www.googleapis.com/auth/devstorage.read_only",
    gcpWrite: "https://www.googleapis.com/auth/devstorage.read_write",
    googleDriveRead: "https://www.googleapis.com/auth/drive.readonly",
    googleDriveWrite: "https://www.googleapis.com/auth/drive.file",
};
export const googleOAuthRedirectUri = ({ uri, app, }) => {
    const url = {
        [Applications.datalab]: `${uri}/data-management/create`,
        [Applications.datascape]: `${uri}/available-data/my-data/egress`,
        [Applications.marketplace]: `${uri}/export`,
        [Applications.studio]: "",
    };
    return url[app];
};
export const cloudFullName = {
    [CloudStorageType.Aws]: "Amazon Web Services",
    [CloudStorageType.Azure]: "Microsoft Azure",
    [CloudStorageType.Sf]: "Snowflake",
    [CloudStorageType.Gcp]: "Google Cloud Platform",
    [CloudStorageType.Upload]: "Upload",
    [CloudStorageType.GoogleDrive]: "Google Drive",
};
export const matchCloudStorageTypeWithIcon = (cloudStorageType) => {
    return match(cloudStorageType)
        .with(CloudStorageType.Aws, () => AWS_LOGO)
        .with(CloudStorageType.Azure, () => AZURE_LOGO)
        .with(CloudStorageType.Sf, () => SNOWFLAKE_LOGO)
        .with(CloudStorageType.Gcp, () => GCP_LOGO)
        .with(CloudStorageType.Upload, () => UPLOAD_LOGO)
        .with(CloudStorageType.GoogleDrive, () => GOOGLE_DRIVE_LOGO)
        .exhaustive();
};
export const matchFileTypeToIcon = (fileExtension) => {
    return match(fileExtension)
        .with(FileType.csv, () => CSV_FILE_ICON)
        .with(FileType.parquet, () => PARQUET_FILE_ICON)
        .with(FileType.geojson, () => GEOJSON_FILE_ICON)
        .with(FileType.geoparquet, () => GEOPARQUET_FILE_ICON)
        .with(FileType.gpkg, () => GEOPACKAGE_FILE_ICON)
        .with(FileType.json, () => JSON_FILE_ICON)
        .with(FileType.xls, () => XLS_FILE_ICON)
        .with(FileType.xlsx, () => XLSX_FILE_ICON)
        .with(FileType.xlsm, () => XLSM_FILE_ICON)
        .with(FileType.xlsb, () => XLSB_FILE_ICON)
        .with(FileType.odf, () => ODF_FILE_ICON)
        .with(FileType.ods, () => ODS_FILE_ICON)
        .with(FileType.odt, () => ODT_FILE_ICON)
        .with(FileType.shp, () => SHAPEFILE_FILE_ICON)
        .with(FileType.zip, () => ZIP_FILE_ICON)
        .otherwise(() => UNSUPPORTED_FILE_ICON);
};
export const fileIconMap = {
    [FileType.csv]: CSV_FILE_ICON,
    [FileType.parquet]: PARQUET_FILE_ICON,
    [FileType.geojson]: GEOJSON_FILE_ICON,
    [FileType.geoparquet]: GEOPARQUET_FILE_ICON,
    [FileType.gpkg]: GEOPACKAGE_FILE_ICON,
    [FileType.json]: JSON_FILE_ICON,
    [FileType.xls]: XLS_FILE_ICON,
    [FileType.xlsx]: XLSX_FILE_ICON,
    [FileType.xlsm]: XLSM_FILE_ICON,
    [FileType.xlsb]: XLSB_FILE_ICON,
    [FileType.odf]: ODF_FILE_ICON,
    [FileType.ods]: ODS_FILE_ICON,
    [FileType.odt]: ODT_FILE_ICON,
    [FileType.unsupported]: UNSUPPORTED_FILE_ICON,
    [FileType.shp]: SHAPEFILE_FILE_ICON,
    [FileType.zip]: ZIP_FILE_ICON,
};
export const logoMap = {
    [CloudStorageType.Aws]: AWS_LOGO,
    [CloudStorageType.Azure]: AZURE_LOGO,
    [CloudStorageType.Sf]: SNOWFLAKE_LOGO,
    [CloudStorageType.Gcp]: GCP_LOGO,
    [CloudStorageType.Upload]: UPLOAD_LOGO,
    [CloudStorageType.GoogleDrive]: GOOGLE_DRIVE_LOGO,
};
const isType = (value, validValues) => {
    return validValues.includes(value);
};
export const getFileIcon = (value) => {
    if (isType(value, Object.values(FileType))) {
        return fileIconMap[value];
    }
    return UNSUPPORTED_FILE_ICON;
};
export const getLogoIcon = (value) => {
    if (isType(value, Object.values(CloudStorageType))) {
        return logoMap[value];
    }
    return UPLOAD_LOGO;
};
export const downloadTypeIconMap = {
    [DownloadType.files]: FILES_ICON,
    [DownloadType.folders]: FOLDERS_ICON,
};
export const ADMIN_STUDIO_PERMISSION = [
    StudioPermission.dataManagement,
    StudioPermission.licenseManagement,
    StudioPermission.marketplace,
    StudioPermission.productManagement,
    StudioPermission.recipeManagement,
    StudioPermission.settings,
    StudioPermission.teamManagement,
];
export const ADMIN_PRODUCT_PERMISSION = [
    ProductPermission.dataLab,
    ProductPermission.datascapeAi,
    ProductPermission.imagery,
    ProductPermission.simulate,
];
export const IS_EMPTYISH = (input) => {
    return !input || input?.trim() === "";
};
//# sourceMappingURL=constants.js.map